import React, { ReactNode } from 'react';

export default function filterFalseyChildren(children: ReactNode): ReactNode[] {
  return React.Children.toArray(children).filter(
    (child) => child != null && typeof child !== 'boolean',
  );
}
